module.exports = __webpack_public_path__ + "img/slider_url-list.41a6c998.png";